import dynamic from 'next/dynamic';
const ScrollToContainer = dynamic(() => import('./ScrollToContainer'));
export default ScrollToContainer;
